import { render } from "./LoadingView.vue?vue&type=template&id=5f03d49d"
import script from "./LoadingView.vue?vue&type=script&lang=js"
export * from "./LoadingView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__